<template>
  <div class="content">
    <div class="container">
      <h1 class="center">
        Dice
      </h1>
    </div>
    <div class="container">
    <Dice />
    </div>
    <br><br><br><br><br>
    <br class="noshow"><br class="noshow">
    <br class="noshow"><br class="noshow">
    <br class="noshow"><br class="noshow">
    <br class="noshow"><br class="noshow">
  </div>
</template>
<script>
import Dice from '../components/Dice';
export default {
  components: {
    Dice,
  }
}
</script>
<style lang="scss" scoped>
</style>